import { makeStyles } from "@material-ui/core";
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 10px',
    height: 35
  },
  title: {
    color: "dimgray", fontWeight: "500", fontSize: "13px"
  },
  viewAll: {
    color: "dimgray",
    padding: '0px 10px',
    borderRadius: "15px", border: "1px solid lightgray", fontSize: "10px",
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  },
  arrowRight: {
    width: "15px", height: "15px", marginTop: "4px"
  }
}));


export function DashboardTitle(props) {
  const classes = useStyles();

  return (
    <>
      <label className={classes.title}>
        {props.title}
      </label>

    </>
  )
}


export function DashboardViewAll() {
  const classes = useStyles();
  return (
    <>
      <div className={classes.viewAll}>
        <div>
          View All
        </div>
        <span>
          <ArrowRightAltIcon className={classes.arrowRight} />
        </span>



      </div>
    </>
  )
}


export function DashboardHeader(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <DashboardTitle {...props} />
      </div>
      <div>
        <DashboardViewAll />
      </div>

    </div>
  )
}